import { getVisiChatInput } from "utils/getVisiChatInput";

import { selectSharepointAuthUrl } from "../selectors";
import { SP_AUTH_REDIRECT_KEY, VISI_PENDING_STATE_KEY } from "./constants";
import { isValidAuthUrl } from "./utils";

export const redirectToSharepointAuthFromCollections =
  () => (dispatch, getState) => {
    const authUrl = selectSharepointAuthUrl(getState());
    const { collections, visi } = getState();

    if (!isValidAuthUrl(authUrl)) return;

    const selectedCollectionIds = (collections?.selectedCollections || []).map(
      (c) => c.id
    );

    const chatInput = getVisiChatInput();
    const hasText = Boolean(chatInput?.textContent?.trim());
    const prompt = hasText ? chatInput.innerHTML : "";
    const documents = visi?.attachedDocuments?.list || [];

    if (prompt || documents.length > 0) {
      localStorage.setItem(
        VISI_PENDING_STATE_KEY,
        JSON.stringify({ prompt, documents, timestamp: Date.now() })
      );
    }

    localStorage.setItem(
      SP_AUTH_REDIRECT_KEY,
      JSON.stringify({
        source: "COLLECTIONS_MODAL",
        selectedCollectionIds,
        timestamp: Date.now(),
      })
    );

    window.location.href = authUrl;
  };
